<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Governance',
  },
})

const page = {
  groupTitle: 'Mutu',
  icon: 'ri-organization-chart',
  color: 'secondary',
  title: 'Struktur Organisasi & Governance',
  description: 'Melihat struktur organisasi, mengelola SK, dan Kebijakan.',
  purpose: 'Panduan melihat struktur organisasi fasilitas Anda dan mengakses dokumen SK/Kebijakan resmi.',
  concept: [
    {
      icon: 'ri-node-tree',
      title: 'Struktur dari Data Unit',
      text: 'Struktur organisasi yang tampil di sini bukan gambar statis — ia digambar otomatis dari data Unit dan hubungan induk-anaknya yang sudah Anda isi di Master Data.',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'SK & Kebijakan = Dokumen Biasa',
      text: 'Sama seperti SOP Klinis, SK dan Kebijakan dikelola lewat mesin Dokumen yang sama, hanya dengan kategori berbeda.',
    },
  ],
  steps: [
    { title: 'Buka menu Mutu → Struktur Organisasi', detail: 'Lihat pohon organisasi lengkap dari Unit teratas sampai unit kerja terkecil.' },
    { title: 'Buka menu Mutu → SK atau Kebijakan', detail: 'Lihat daftar dokumen SK/Kebijakan yang sudah terbit.' },
    { title: 'Klik "Buat SK"/"Buat Kebijakan" untuk menambah baru', detail: 'Anda akan diarahkan ke form Dokumen dengan kategori sudah terisi otomatis.' },
  ],
  tips: [
    'Kalau struktur organisasi terlihat salah, perbaiki lewat Master Data → Unit, bukan di halaman ini — halaman ini murni tampilan baca-saja.',
  ],
  faq: [
    { q: 'Kenapa unit saya tidak muncul di struktur organisasi?', a: 'Kemungkinan kolom "Unit Induk"-nya belum diisi di Master Data → Unit. Cek dan lengkapi di sana.' },
  ],
  related: [
    { title: 'Master Data', sub: 'Kelola Unit dan struktur induk-anaknya', icon: 'ri-database-2-line', color: 'error', to: { name: 'help-administrasi-master-data' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
